export var teamsIconClassNames = {
  filled: 'ui-icon__filled',
  outline: 'ui-icon__outline'
};